import { CommonModule, CurrencyPipe } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DividerModule } from 'primeng/divider';
import { ImageModule } from 'primeng/image';
import { Table, TableModule } from 'primeng/table';
import { Clinic } from 'src/app/models/clinic.model';
import { User } from 'src/app/models/user.model';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'users-table',
  standalone: true,
  imports: [
    TableModule,
    ImageModule,
    ButtonModule,
    AvatarModule,
    CommonModule,
    DialogModule,
    DividerModule,
    CurrencyPipe,
    InputTextModule,
  ],
  templateUrl: './user-table.component.html',
})
export class UserTableComponent implements OnInit {
  @Input()
  data: User[];

  @Input()
  clinic: Clinic;

  cols: any[];
  user: User;
  isExpanded: boolean = false;
  viewModal: boolean = false;

  constructor(private readonly router: Router) {}

  ngOnInit(): void {
    this.cols = [
      { field: 'name', header: 'Nombre' },
      { field: 'apellidos', header: 'Apellidos' },
      { field: 'email', header: 'Email' },
      { field: 'phoneNumber', header: 'Teléfono' },
      { field: 'zipCode', header: 'Código Postal' },
    ];
  }

  view(user: User) {
    this.user = { ...user };
    this.viewModal = true;
  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }
}
